import React, { useRef, useState, useEffect } from "react";
import useAdminDataStore, { selectCurrentGroupData } from "../../../../../store/adminData/adminData";
import ChantButton from "../../../../../CommonComponents/ChantButton/ChantButton";
import GroupQR from "../../../../../CommonComponents/GroupQR/GroupQR";

const QR_SIZE = 160;

const styles = {
  page: {
    padding: "24px",
    backgroundColor: "#ffffff",
  },
  row: {
    display: "flex",
    alignItems: "flex-start",
    gap: "24px",
    padding: "20px",
    border: "1px solid #e8e8e8",
    borderRadius: "10px",
    marginBottom: "16px",
    backgroundColor: "#fafafa",
  },
  qrWrapper: {
    width: QR_SIZE,
    height: QR_SIZE,
    flexShrink: 0,
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 1px 4px rgba(0,0,0,0.10)",
    backgroundColor: "#ffffff",
  },
  content: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: "6px",
  },
  title: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#111111",
    margin: 0,
  },
  description: {
    fontSize: "14px",
    color: "#555555",
    lineHeight: 1.55,
    margin: 0,
  },
};

const QrRow = ({ qrRef, url, downloadName, title, description }) => (
  <div style={styles.row}>
    <div style={styles.qrWrapper}>
      <GroupQR ref={qrRef} url={url} size={QR_SIZE} downloadName={downloadName} />
    </div>
    <div style={styles.content}>
      <p style={styles.title}>{title}</p>
      <p style={styles.description}>{description}</p>
      <div style={{ marginTop: "8px" }}>
        <ChantButton onClick={() => qrRef.current?.download()}>Download</ChantButton>
      </div>
    </div>
  </div>
);

const PromoteQrCodes = () => {
  const [packages, setPackages] = useState([]);
  const [isStadiumPublished, setIsStadiumPublished] = useState(false);

  const adminData = useAdminDataStore(selectCurrentGroupData);

  const appStoreQrRef = useRef(null);
  const regQrRef = useRef(null);
  const regGroupQrRef = useRef(null);
  const stadiumQrRef = useRef(null);
  const chantsQrRef = useRef(null);

  useEffect(() => {
    if (adminData?.data?.groupName) {
      setPackages([{ id: 1 }]);
      setIsStadiumPublished(true);
    }
  }, [adminData]);

  const groupSlug = adminData?.data?.groupName?.toLowerCase().replace(/ /g, "");

  return (
    <div style={styles.page}>
      <QrRow
        qrRef={appStoreQrRef}
        url="https://apps.apple.com/in/app/chant/id1477159385"
        downloadName="app-store-qr"
        title="App Download"
        description="Use this general QR code for access to Chant in the app stores. Members must first be pre-registered (via Onboard options #1-3) for group access."
      />

      {packages.length > 0 && (
        <QrRow
          qrRef={regQrRef}
          url={`https://group.chant.fan/${groupSlug}/join`}
          downloadName="membership-qr"
          title="Membership Packages"
          description="Use this QR code as a direct link to the group's web registration page (membership packages)."
        />
      )}

      {adminData?.registrationLink && (
        <QrRow
          qrRef={regGroupQrRef}
          url={adminData.registrationLink}
          downloadName="group-access-qr"
          title={`Group access (${adminData?.regCodeRole === "fan" ? "Non-member" : "Member"})`}
          description="Provide group access with no pre-registration required (anyone with code can enter group). Use Onboard option #4 and set access for Members (full app access) or Non-members (restricted access to some app features)."
        />
      )}

      {isStadiumPublished && (
        <QrRow
          qrRef={stadiumQrRef}
          url={`https://group.chant.fan/${groupSlug}/stadium`}
          downloadName="stadium-qr"
          title="Stadium"
          description="Use this QR code as a direct link to the group's stadium page."
        />
      )}

      {adminData?.configuration?.isChantsPublished && (
        <QrRow
          qrRef={chantsQrRef}
          url={`https://group.chant.fan/${groupSlug}/chants`}
          downloadName="chants-qr"
          title="Chants"
          description="Use this QR code as a direct link to the group's web chants page."
        />
      )}
    </div>
  );
};

export default PromoteQrCodes;
